<template>
  <div class="flex items-center gap-1.5">
    <select
      class="flex-1 text-sm bg-slate-700/80 text-white border border-slate-500 rounded px-2 py-1 focus:outline-none focus:border-cyan-500 appearance-none"
      :value="modelValue || ''"
      @change="onChange($event.target.value)"
    >
      <option value="">— No Font Family —</option>
      <optgroup label="Project Fonts">
        <option v-for="f in projectFonts" :key="f.uuid" :value="f.file" :disabled="!f.file">
          {{ f.name }}{{ f.file ? '' : ' (no device path set)' }}
        </option>
      </optgroup>
    </select>
    <button
      v-if="modelValue"
      class="text-slate-400 hover:text-red-400 p-1 rounded hover:bg-slate-600 transition-colors flex-shrink-0"
      title="Clear Font Family"
      @click="onChange('')"
    >
      <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
      </svg>
    </button>
  </div>
</template>

<script setup>
/**
 * FontFamilyPicker.vue — Label's Font Family property editor.
 *
 * Unlike the generic ResourcePicker (which stores a project resource's
 * uuid), this stores the actual wire-format font-family string directly:
 * a project Font Resource's on-device `file` path. The browser's bundled
 * Roboto Condensed face is only a preview fallback and is deliberately not
 * offered here or written into firmware exports.
 */
import { computed } from 'vue'
import { useFontStore } from '../../stores/fontStore.js'

defineProps({
  resourceType: { type: String, required: true },
  modelValue: { type: String, default: '' },
})
const emit = defineEmits(['update:modelValue'])

const projectFonts = computed(() => useFontStore().all)

function onChange(value) {
  emit('update:modelValue', value)
}
</script>
